import { BoxProps } from '@jfs/ui-new'

export enum filterTypes {
  transactionStatus = 'transactionStatus',
  paymentMode = 'paymentMode',
  paymentLinkStatus = 'paymentLinkStatus',
  subscriptionStatus = 'subscriptionStatus',
  subscriptionRevocable = 'subscriptionRevocable',
  subscriptionDateType = 'subscriptionDateType',
  subscriptionPaymentMode = 'subscriptionPaymentMode',
  subscriptionDateRangeType = 'subscriptionDateRangeType',
  campaignType = 'campaignType',
  campaignStatus = 'campaignStatus',
  mid = 'mid',
}

export interface FilterProps {
  onPress: () => void
  apply: () => void
  updateMin: (data: string) => void
  updateMax: (data: string) => void
  selectedFilteredData: any
  updateFilters: (mode: filterTypes, value: string) => void
  checkSelected: (mode: filterTypes, value: string) => boolean
  updateFilterSettings: (data: any) => void
  filterData: any
  filterHeader: any
  filtersStrings: any
  path?: string
  updateOtherFilters?: (value: string, type: string) => void
  clearSubscriptionFilters: () => void
  subMids?: any
  showMidFilter?: boolean
}

export interface FilterDataprops {
  min: string
  max: string
  transactionStatus: Array<string>
  paymentMode: Array<string>
}

export interface FilterItemProps {
  mode: filterTypes
  updateFilters: (mode: filterTypes, value: string) => void
  checkSelected: (mode: filterTypes, value: string) => boolean
  header: string
  filterData: any
  hide?: boolean
  selectedValue?: string
}

export interface CLFilterProps {
  filterData: any
  updateFilters: (mode: filterTypes, value: string) => void
  style: BoxProps
  selectedValue?: string
  mode: filterTypes
}
